import { render, staticRenderFns } from "./sortTable.vue?vue&type=template&id=1ae2b7c2"
import script from "./sortTable.vue?vue&type=script&lang=js"
export * from "./sortTable.vue?vue&type=script&lang=js"
import style0 from "./sortTable.vue?vue&type=style&index=0&id=1ae2b7c2&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports